export default {
  LOGIN_OTP: '/auth/login',
  VERIFY_LOGIN_OTP: '/staff-auth/verify-login-otp',
  USER_LOGOUT: '/staff-auth/logout',
  AUTH_REFRESH_TOKEN: '/auth/refresh-tokens',
  CURRENT_USER: '/staff/self',
  CURRENT_CLIENT: '/customer/self',
  CLIENT_LIST: '/customer/list',
  CREATE_CLIENT: '/customer/create',
  GET_CLIENT_BY_ID: '/customer',
  UPDATE_CLIENT: '/customer',
  DELETE_CLIENT: '/customer/delete',
  COMPANY_LIST: '/company/list',
  COMPANY: '/company',
  LOCATION_LIST: '/locations',
  CREATE_LOCATION: '/locations',
  UPDATE_LOCATION: '/locations',
  DELETE_LOCATION: '/locations',
  ROOM_LIST: '/rooms',
  ROOM_LIST_SCHEDULE: '/rooms/scheduling',
  CREATE_ROOM: '/rooms',
  UPDATE_ROOM: '/rooms',
  DELETE_ROOM: '/rooms',
  UPDATE_ROOMS: '/rooms/updateRooms',
  USERS: '/users/getAllUsers',
  CREATE_USERS: '/users/createUsers',
  UPDATE_USERS: '/users/updateUsers',
  USERS_URL: '/users/',
  UPLOAD: '/rooms/upload',
  UPLOAD_PDF: '/rooms/upload-pdf',
  BOOKINGS: '/bookings',
  NEW_BOOKINGS: '/bookings/byDate/booking',
  ORGANIZATION: '/organizations',
  DEVICES: '/devices',
  DEVICES_LOGS_HA: '/logs/ha',
  DEVICE_LIST: '/devicesha',
  STATS: '/stats',
  ROOM_CHART: '/chart/room',
  ROOM_FLOORS: '/chart/floors',
  FLOORS_LOCATION: '/chart/location',
  FLOOR_NUMBER: '/rooms/floors',
  FLOOR_NUMBERS: '/rooms/floor',
  ROOM_DEVICE_LOGS: '/rooms/devicelogs',
  FLOOR_ROOM_STATE: '/rooms/floor/room-state',
  FLOOR_MAPPING: '/floor-master/list',
  RENDER_BOOKING_DATA: '/sync/render/bookings',
  ROOM_DISPLAY_ACCOUNTS: '/users/room-display',
};
